// export const API_BASE_URL =
//   "https://api-dev-skillangllm.webdadsprojects.com/api";
// export const API_BASE_URL = "http://192.168.1.16:5000/api";
export const API_BASE_URL = process.env.REACT_APP_API_URL
